"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 多上传文件组件
 *
 * uploadParams: {
 *    resourceConfigFlag: 'sfe_store'
 * }
 */
/** statics */
var default_keys = ['fileName', 'url'];
var _default2 = exports.default = {
  name: 'FormUploadFile',
  props: {
    urlList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // url的key数组 [nameKey, urlKey]
    keys: {
      type: Array,
      default: function _default() {
        return default_keys;
      }
    },
    // 最大限制，单位MB（当前默认值为后端上传api最大接受值）
    maxSize: {
      type: Number,
      default: 50
    },
    // 上传额外携带的参数
    uploadParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 限制数量 0 不限制
    limit: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      preUpload: [],
      isLoading: false,
      dialogImageUrl: '',
      dialogVisible: false,
      elMsg: null // $message 对象
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    nameKey: function nameKey() {
      return this.keys[0] || default_keys[0];
    },
    urlKey: function urlKey() {
      return this.keys[1] || default_keys[1];
    }
  },
  methods: {
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove: function handleRemove(file) {
      // console.log(111, file)
      var index = this.urlList.map(function (i) {
        return i.url;
      }).indexOf(file.url);
      if (index >= 0) {
        this.urlList.splice(index, 1);
      }
    },
    setUrl: function setUrl(urlObj) {
      // console.log('更新urlList', urlObj)
      this.urlList.push(urlObj);
    },
    // 预上传列表移除对应key
    removeKey: function removeKey(fileKey) {
      var index = this.preUpload.indexOf(fileKey);
      if (index >= 0) {
        this.preUpload.splice(index, 1);
      }
    },
    // 上传
    uploadData: function uploadData(file, fileList) {
      // console.log('上传', file, fileList)
      // 数据状态初始化
      var rawFile = file.raw;
      // 大小限制
      if (this.checkSize(rawFile)) {
        return false;
      }
      this.singleUpload(rawFile);
    },
    // 超出限制
    onExceed: function onExceed(filesAdd, fileList) {
      var _this = this;
      console.log('超出限制', filesAdd, fileList);
      var default_files = Array.from(filesAdd);
      if (!this.limit) {
        console.log('没有数量限制');
        return false;
      }
      this.$message.warning("".concat(this.$t('errorValid.validMultiFile'), ": ").concat(this.limit));
      // 大小限制
      var files = default_files.filter(function (rawFile) {
        return !_this.checkSize(rawFile);
      });
      // 给出提示，并上传限制数量内的其余文件
      var diffLen = this.limit - (this.urlList.length + this.preUpload.length);
      if (diffLen > 0) {
        if (diffLen > files.length) {
          // 按逻辑这里不可能发生，预留
          files.forEach(function (i) {
            _this.singleUpload(i);
          });
        } else {
          files.splice(0, diffLen).forEach(function (i) {
            _this.singleUpload(i);
          });
        }
      }
    },
    /**
     * 文件大小超出限制
     * @param {File} rawFile // 文件列表
     * @return {boolean} // 是否有错误
     */
    checkSize: function checkSize(rawFile) {
      // console.log('checkSize', rawFile)
      var hasError = false;
      // 大小限制
      if (this.maxSize && rawFile.size > this.maxSize * 1024 * 1024) {
        // 目前改组件多文件上传只有图片（展示也是图片），如果扩展上传文件请自行修改组件
        this.elMsg && this.elMsg.close && this.elMsg.close();
        this.elMsg = this.$message.error("".concat(this.$t('common.uploadLimitDesc1')).concat(this.maxSize).concat(this.$t('common.uploadLimitDesc2')));
        hasError = true;
      } else {
        hasError = false;
      }
      return hasError;
    },
    // 单个文件上传
    singleUpload: function singleUpload(rawFile) {
      var _this2 = this;
      if (!rawFile) return;
      // // 大小限制||压缩图片
      // if (this.maxSize && rawFile.size > this.maxSize * 1024 * 1024) {
      //   this.elMsg && this.elMsg.close && this.elMsg.close()
      //   this.elMsg = this.$message.error(`请上传小于${this.maxSize}M的图片`)
      //   return
      // }
      // 生成key
      var fileKey = "__key_".concat(Math.random());
      this.preUpload.push(fileKey);
      this.isLoading = true;
      var param = new FormData();
      param.append('file', rawFile);
      // 额外参数
      Object.keys(this.uploadParams).forEach(function (key) {
        param.append(key, _this2.uploadParams[key]);
      });
      this.$api.common.uploadFile(param).then(function (res) {
        // console.log(999, res)
        var data = res.data || {};
        _this2.setUrl((0, _defineProperty2.default)((0, _defineProperty2.default)({}, _this2.nameKey, rawFile.name), _this2.urlKey, data.url || ''));
      }).finally(function () {
        _this2.removeKey(fileKey);
        _this2.$nextTick(function () {
          if (_this2.preUpload.length <= 0) {
            _this2.isLoading = false;
          }
        });
      });
    }
  }
};